import { CompanyType } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { FieldValues } from 'react-hook-form';

import AutocompleteField from '../v2/Autocomplete/AutocompleteField';
import { AutocompleteFieldProps } from '../v2/Autocomplete/types';

export const humanReadableCompanyTypes: Record<CompanyType, string> = {
  [CompanyType.BROKER]: t('enums.company_type.broker'),
  [CompanyType.CONTRACTOR]: t('enums.company_type.contractor'),
  [CompanyType.HAULER]: t('enums.company_type.hauler'),
  [CompanyType.OWNER_OPERATOR]: t('enums.company_type.owner_operator'),
  [CompanyType.PRODUCER]: t('enums.company_type.producer'),
  [CompanyType.SUPER]: t('enums.company_type.super'),
};

const companyTypes = Object.keys(CompanyType) as (keyof typeof CompanyType)[];
const options = companyTypes.map((type) => {
  const value = CompanyType[type];

  return { label: humanReadableCompanyTypes[value], value, _entity: value };
});

type Props<T extends FieldValues> = Omit<
  AutocompleteFieldProps<T, CompanyType>,
  'options'
> & { isSuperCompanyTypeAvailable?: boolean };

export default function AutocompleteCompanyTypes<T extends FieldValues>({
  isSuperCompanyTypeAvailable,
  ...rest
}: Props<T>) {
  const effectiveOptions = isSuperCompanyTypeAvailable
    ? options
    : options.filter((option) => option.value !== CompanyType.SUPER);

  return <AutocompleteField {...rest} options={effectiveOptions} />;
}
